var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen"},[_c('div',{staticClass:"bg-lightGray grid grid-cols-12 lg:grid-cols-12"},[_c('div',{staticClass:"col-span-12"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }